import {TagDto} from './tag-dto';
import {Tag} from './tag';
export function mapTag(tag: TagDto): Tag { return {usageCount: tag.usageCount, id: tag.id, name: tag.name, authorId: tag.authorUserId, authorName: tag.authorName}; }
